import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../../../app/GetProxy";

const cookies = new Cookies();
const proxy = GetProxy();

const getAuthHeaders = () => ({
  Accept: "application/json",
  "Content-Type": "application/json",
  "DTOP-API-TOKEN": cookies.get("apitoken"),
  USERNAME: cookies.get("username"),
});

export const getLoginBanner = createAsyncThunk(
  "loginPageConfig/getLoginBanner",
  async () => {
    const res = await fetch(`${proxy}/sassp/login-banner`, {
      method: "GET",
      headers: getAuthHeaders(),
    }).then((resp) => resp.json());
    return res;
  }
);

export const saveLoginBanner = createAsyncThunk(
  "loginPageConfig/saveLoginBanner",
  async (payload) => {
    const res = await fetch(`${proxy}/sassp/login-banner`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    }).then((resp) => resp.json());
    return res;
  }
);

export const LoginPageConfigSlice = createSlice({
  name: "loginPageConfig",
  initialState: {
    bannerData: null,
    bannerLoading: false,
    saveLoading: false,
    apiError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLoginBanner.pending, (state) => {
        state.bannerLoading = true;
        state.apiError = false;
      })
      .addCase(getLoginBanner.fulfilled, (state, action) => {
        state.bannerData = action.payload;
        state.bannerLoading = false;
        state.apiError = false;
      })
      .addCase(getLoginBanner.rejected, (state) => {
        state.bannerLoading = false;
        state.apiError = true;
      })
      .addCase(saveLoginBanner.pending, (state) => {
        state.saveLoading = true;
        state.apiError = false;
      })
      .addCase(saveLoginBanner.fulfilled, (state) => {
        state.saveLoading = false;
        state.apiError = false;
      })
      .addCase(saveLoginBanner.rejected, (state) => {
        state.saveLoading = false;
        state.apiError = true;
      });
  },
});

export default LoginPageConfigSlice.reducer;
